import { defineStore, getActivePinia } from 'pinia'

export const resetAllStores = () => {
  // reset all stores besides those are used for authentication, permissions, speckle
  const activePinia = getActivePinia()
  if (!activePinia) {
    return
  }
  for (const [storeName, state] of Object.entries(activePinia.state.value)) {
    if (
      ['authorization', 'projectUsers', 'auth', 'speckleAuth', 'notifications'].includes(storeName)
    ) {
      continue
    }
    const storeDefinition = defineStore(storeName, state)
    const store = storeDefinition(activePinia)
    store.$reset()
  }
}
